import { observer } from "mobx-react-lite"
import React, {  } from "react"
import { Information } from "../components/Information";
import { MainDesk } from "../components/MainDesk";
import { UniversalContent } from "../components/UniversalContent";
import { BiLanguageForm } from "../components/forms/BiLanguageForm";
import { InputTextField } from "../components/forms/InputTextField";
import { contentStore } from "../store/Store";
import { OptionsContainer } from "../styles/ContentStyles";
import { GlobalBilanguageZone } from "../components/GlobalBilanguageToggler";

const City = () => {
    const CityMainDesk = () => (
        <MainDesk numOfLeftChildren={3}>
                <BiLanguageForm label="Name">
                    <InputTextField
                        required={true}
                        obj={contentStore.item?.title}
                    />
                </BiLanguageForm>
        </MainDesk>
    );

    const CityOptions = () => (
        <OptionsContainer>
            <Information 
                obj={contentStore.item}
            />
        </OptionsContainer>
    )

    return (
        <UniversalContent 
            MainDeskComponent={CityMainDesk}
            OptionsContainerComponent={CityOptions}
        />
    )
}

const o = observer(City)
export {o as City}